import { render, staticRenderFns } from "./cardborder.vue?vue&type=template&id=5915a604&scoped=true&"
import script from "./cardborder.vue?vue&type=script&lang=js&"
export * from "./cardborder.vue?vue&type=script&lang=js&"
import style0 from "./cardborder.vue?vue&type=style&index=0&id=5915a604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915a604",
  null
  
)

export default component.exports